import { render, staticRenderFns } from "./AddInputData.vue?vue&type=template&id=3dca50dc"
import script from "./AddInputData.vue?vue&type=script&lang=js"
export * from "./AddInputData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports